"use client";

import React, { useEffect, useState } from 'react';
import HomeProjects from './HomeProjects.';
import HomeHeader from './HomeHeader';
import Loader from './Loader';
import { PortfolioData } from '../context';
import { cn } from '../../lib/utils';

const Home = () => {
  const { projects } = PortfolioData();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);


    useEffect(() => {
        if (projects) {
          setData(projects);
          setTimeout(() => {
            setLoader(false);
          }, 400)
        }
    },[projects]);

  return (
    <div className="homeV3">
        <div
          className={cn(
            "absolute inset-0 top-0 h-[calc(100vh-152px)] w-full",
            "[background-size:40px_40px]",
            "[background-image:linear-gradient(to_right,#e4e4e7_1px,transparent_1px),linear-gradient(to_bottom,#e4e4e7_1px,transparent_1px)]",
            "dark:[background-image:linear-gradient(to_right,#262626_1px,transparent_1px),linear-gradient(to_bottom,#262626_1px,transparent_1px)]",
          )}
        />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] dark:bg-black"></div>
        <HomeHeader />
        {data?.length > 0 && <HomeProjects data={data} />}
        {loader && <Loader />}
    </div>
  );
};

export default Home;
